<template>
  <div>
    <ht-template-form
      ref="templateForm"
      :template-key="templateKey"
      :event-script="eventScript"
      :action="action"
      :is-share="isShare"
      :open-type="openType"
      :data-param="params"
      :is-custom-handle-close="isShortUrl"
      :hide-back-btn="isFullscreen"
      @close="handleClose"
      @template-print="templatePrint"
    ></ht-template-form>
    <el-dialog
      :title="$t('eip.common.printTemplate')"
      width="30%"
      :visible.sync="printDialogVisible"
      :close-on-click-modal="false"
    >
      <el-form class="centered-form">
        <el-form-item :label="$t('page.formPrint.selectTemplate')">
          <el-select
            v-model="selectTemplate"
            :placeholder="$t('page.leaderDialog.pleaseSelect')"
          >
            <el-option
              v-for="template in templatePrintList"
              :key="template.fileId"
              :label="template.fileName"
              :value="template.fileId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="printDialogVisible = false">
          {{ $t('eip.common.cancel') }}
        </el-button>
        <el-button type="primary" @click="onConfirmPrint">
          {{ $t('eip.common.print') }}
        </el-button>
        <el-button type="primary" @click="onConfirmDownload">
          {{ $t('eip.common.download') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import { getFormPrintTemplateByForKey } from '@/api/flow.js'
  import { wordPrint } from '@/api/form.js'
  import portal from '@/api/portal.js'
  export default {
    name: 'TemplateForm',
    props: {
      templateKey: {
        type: String,
        default: '',
      },
      action: {
        type: String,
        default: '',
      },
      isShare: {
        type: Boolean,
      },
      openType: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        selectTemplate: '',
        printDialogVisible: false,
        templatePrintList: [],
        key: this.templateKey,
        single: true,
        params: null,
        boAlias: '',
        eventScript: '',
      }
    },
    computed: {
      isShortUrl() {
        // eslint-disable-next-line no-prototype-builtins
        return this.$route.query.hasOwnProperty('isShortUrl')
      },
      isFullscreen() {
        const __isFull__ = this.$route.query.__isFull__
        return __isFull__ && Boolean(__isFull__)
      },
    },
    created() {
      if (!this.key && this.$route.meta.templateKey) {
        this.key = this.$route.meta.templateKey
      }

      this.params = this.$route.params.data
      this.eventScript = this.$route.query.eventScript
    },
    methods: {
      async onConfirmDownload() {
        if (!this.selectTemplate) {
          this.$message.error('请选择下载模板')
          return
        }
        try {
          const result = this.templatePrintList.filter(
            (item) => item.fileId === this.selectTemplate
          )[0]
          const boData = this.$refs.templateForm.data
          const data = {
            boData: JSON.stringify(boData),
            fileId: result.fileId,
            formKey: this.boAlias,
            id: result.templateId,
          }
          const { value } = await wordPrint(data)
          portal.downloadFile(value)
        } catch (error) {
          this.$message.error('套打失败')
        }
      },
      async onConfirmPrint() {
        if (!this.selectTemplate) {
          this.$message.error('请选择打印模板')
          return
        }
        try {
          const result = this.templatePrintList.filter(
            (item) => item.fileId === this.selectTemplate
          )[0]
          const boData = this.$refs.templateForm.data
          const data = {
            boData: JSON.stringify(boData),
            fileId: result.fileId,
            formKey: this.boAlias,
            id: result.templateId,
          }
          const { value } = await wordPrint(data)
          const { pdfUrl } = await portal.onlinePreview(value)
          window.open(window.context.gatewayUrl + pdfUrl)
        } catch (error) {
          this.$message.error('套打失败')
        }
      },
      async templatePrint(boAlias) {
        this.boAlias = boAlias
        const result = await getFormPrintTemplateByForKey(boAlias)
        const temList = []
        if (!!result && result.length > 0) {
          result.forEach((element) => {
            const file = JSON.parse(element.fileJson)
            temList.push({
              fileId: file[0].id,
              fileName: element.name,
              createTime: element.createTime,
              templateId: element.id,
            })
          })
          this.$set(this, 'templatePrintList', temList)
          this.printDialogVisible = true
        } else {
          this.$message.error('未找到打印模板')
        }
      },
      handleClose() {
        window.location.href = 'about:blank'
        window.close()
      },
    },
  }
</script>

<style scoped>
  ::v-deep .el-dialog__body {
    padding: 30px 20px !important;
  }
</style>
